function ResolutionOptionService(ApiService) {
  'ngInject';
  const service = {};

  service.listResolution = function (url, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.updateResolution = function (addUserForm, callbackFunc) {
    ApiService.patch(`/resolution_options/${addUserForm.id}.json`, addUserForm, callbackFunc);
  };

  service.deleteResolution = function (resolutionId, callbackFunc) {
    ApiService.delete(`/resolution_options/${resolutionId}.json`, { id: resolutionId }, callbackFunc);
  };

  service.newResolution = function (resolution, callbackFunc) {
    ApiService.post(`/resolution_options.json`, resolution, callbackFunc);
  };
  return service;
}

export default {
  name: 'ResolutionOptionService',
  fn: ResolutionOptionService
};